import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthTokens, MeResponse } from '@ah/contracts';

/**
 * Real auth store for the therapist portal (replaces the temporary
 * `?token=` bridge — see shared/stores/session.store.ts, now deleted).
 * Same shape and persistence strategy as apps/mobile/src/features/auth/auth.store.ts:
 * only the token pair is persisted to localStorage; `user` is kept in memory
 * and set directly from the login response (this app has no /me rehydration
 * on load either, matching mobile's current behavior).
 */
export interface AuthState {
  tokens: AuthTokens | null;
  user: MeResponse | null;
  setSession: (payload: { tokens: AuthTokens; user: MeResponse }) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      tokens: null,
      user: null,
      setSession: ({ tokens, user }) => set({ tokens, user }),
      signOut: () => set({ tokens: null, user: null }),
    }),
    {
      name: 'ah.therapist.auth',
      partialize: (state) => ({ tokens: state.tokens }),
    },
  ),
);
